import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.locale("fr");

export const formatEducationPeriod = (start: string, end: string, present: boolean) => {
  if (!start) return "";
  const print = (value: string) => {
    const parsed = dayjs(value, "YYYY-MM", true);
    return parsed.isValid() ? parsed.format("MMMM YYYY") : value;
  };
  return present
    ? `${print(start)} – En cours`
    : end
      ? `${print(start)} – ${print(end)}`
      : print(start);
};

export const plainText = (value = "") =>
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
